module.exports = __webpack_public_path__ + "stockLibrary/service_2-f02706e9e45f9a17b14ac2462356bc79.png";